var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('a',{staticClass:"artifacts-generator navbar-brand m-0"},[_c('img',{attrs:{"src":require("../../public/logo-brand.png"),"height":"30","alt":"Forja Mística"}}),_vm._v("\n  Forja Mística\n")])}]

export { render, staticRenderFns }